var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"id":"modalMedicalRecord","size":"xl","title":"Pilih Rekam Medis","hide-footer":""}},[_c('Table',{attrs:{"purpose":"modal"},on:{"chooseData":_vm.chooseData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }